import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/config/siteConfig";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const LegalLayout = ({ title, updatedAt, children, testId }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white font-sans text-black antialiased">
      <Header />
      <main className="mx-auto max-w-3xl px-4 pb-24 pt-32 md:px-8 md:pt-40" data-testid={testId}>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-gray-500 transition-colors duration-300 hover:text-black"
        >
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl">{title}</h1>
        <p className="mt-3 text-sm text-gray-400">Dernière mise à jour : {updatedAt}</p>
        <div className="mt-10 space-y-10 text-base leading-relaxed text-gray-700">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="mb-3 font-display text-xl font-bold text-black">{title}</h2>
    {children}
  </section>
);

export { SITE };
export default LegalLayout;
